module.exports = __webpack_public_path__ + "static/media/netify-logo.bf3efff2.png";